export default __webpack_public_path__ + "static/stars-69139101e31e484fd8162f89b61a1890.webp";